import { z } from 'zod';
import { DateTime } from 'luxon';
import { FormField } from '../../../dynamic-form.types';

export const buildDateFieldSchema = (field: FormField) => {
  const isRequired = field.rules.required.value ?? false;
  const errorMessage = field.rules.required.copy;

  if (isRequired) {
    return z.preprocess(
      (val) => (val === null || val === undefined ? '' : val),
      z.string().refine(
        (val) => {
          if (val == null || val === '') {
            return false;
          }
          const dateTime = DateTime.fromISO(val);
          return dateTime.isValid;
        },
        {
          message: errorMessage,
        }
      )
    );
  } else {
    return z
      .string()
      .optional()
      .refine(
        (val) => {
          if (val === undefined || val === null || val === '') {
            return true;
          }
          const dateTime = DateTime.fromISO(val);
          return dateTime.isValid;
        },
        {
          message: errorMessage,
        }
      );
  }
};
